import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend';
import './Dialog_DiscardProvideInfo.scss';
import { ICONS } from '@app/styles';
export class Dialog_DiscardProvideInfo extends ComponentSync {
    static dialogKey = 'dialog__discard-provide-info';
    static show = (props) => {
        const model = {
            dialogKey: Dialog_DiscardProvideInfo.dialogKey,
            content: () => _jsx(Dialog_DiscardProvideInfo, { ...props }),
            closeOverlayOnClick: () => false,
        };
        ModuleFE_Dialog.show(model);
    };
    //######################### Logic #########################
    onCancel = () => {
        ModuleFE_Dialog.close();
    };
    onSave = async () => {
        await this.props.onSave();
        ModuleFE_Dialog.close();
    };
    onDiscard = () => {
        this.props.onDiscard();
        ModuleFE_Dialog.close();
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { id: 'd_dpi', children: [this.render_Message(), this.render_Actions(), _jsx(ICONS.advisor_avn_close.component, { onClick: this.onCancel })] });
    }
    render_Message = () => {
        return _jsxs(LL_V_L, { className: 'd_dpi__message', children: [_jsx("h1", { children: "You have unsaved data" }), _jsx("h2", { children: "Save your data to continue later" })] });
    };
    render_Actions = () => {
        return _jsxs(LL_H_C, { className: 'd_dpi__actions', children: [_jsx(Button, { variant: 'secondary', onClick: this.onDiscard, children: "Discard Changes" }), _jsx(Button, { variant: 'primary', onClick: this.onSave, children: "Save & Exit" })] });
    };
}
//# sourceMappingURL=Dialog_DiscardProvideInfo.js.map